const VERSION_KEY = 'app_version';

let isDeferred = false;
let deferredVersion: string | null = null;

export const versionManagement = {
  getCurrentVersion: () => {
    return localStorage.getItem(VERSION_KEY);
  },

  setVersion: (version: string) => {
    localStorage.setItem(VERSION_KEY, version);
  },

  deferReloads: () => {
    isDeferred = true;
  },

  resumeReloads: () => {
    isDeferred = false;

    const pendingVersion = deferredVersion;
    deferredVersion = null;

    if (pendingVersion) {
      versionManagement.checkAndHandleVersion(pendingVersion);
    }
  },

  checkAndHandleVersion: (responseVersion: string) => {
    const currentVersion = versionManagement.getCurrentVersion();
    
    if (currentVersion && currentVersion !== responseVersion) {
      if (isDeferred) {
        deferredVersion = responseVersion;
        return;
      }

      versionManagement.setVersion(responseVersion);
      window.location.reload();
    } else if (!currentVersion) {
      versionManagement.setVersion(responseVersion);
    }
    
  }
};
